




























import { Component, Mixins, VModel } from 'vue-property-decorator';

import ModelSetter from "../../../../Mixins/ModelSetter";
import TextInput from "../../../Pi/fields/TextInput/TextInput.vue";
import { StripeRegister } from "../types";

@Component({
  components: {
    TextInput
  }
})
export default class StripeSetting extends Mixins(ModelSetter) {
  @VModel() model!: StripeRegister
}
